<template>
  <UiNarrowContainer class="py-28">
    <div
      :class="[
        'flex flex-col rounded-xl',
        { 'max-w-full': content.max_width === 'large' },
        { 'max-w-xl': content.max_width === 'medium' },
        { 'max-w-sm': content.max_width === 'small' },
        { 'p-12': content.padding === 'medium' },
        { 'p-4': content.padding === 'small' },
        { 'bg-gray-100': content.background_color === 'gray' },
        { 'bg-white': content.background_color === 'white' },
        { 'text-left': content.text_alignment === 'left' },
        { 'text-center': content.text_alignment === 'center' },
        { 'text-right': content.text_alignment === 'right' },
      ]"
    >
      <UiRichTextContent :content="content.content" />
    </div>
  </UiNarrowContainer>
</template>

<script setup lang="ts">
import type { PageRichTextProps } from '~/components/Page/types';

defineProps<PageRichTextProps>();
</script>
